import { translate } from '@avensia/excite';
import { TestIdProps } from '@avensia/test-automation';
import { Button } from 'webapp/components/button';
import { isSvenssons, Theme } from 'webapp/theme';
import { useFlyout } from 'webapp/shell/flyout-context';
import { CloseIcon, MenuIcon } from 'webapp/components/icons';

export function MenuButton() {
  const { open, isOpen, close } = useFlyout('Menu');

  return (
    <Button
      {...TestIdProps.ToggleSidebarMenu}
      square
      disableRippleEffect
      as={Theme.Transparent}
      aria-label={translate(t => t.header.menu)}
      onClick={isOpen ? close : open}
    >
      {isOpen && isSvenssons ? <CloseIcon /> : <MenuIcon />}
    </Button>
  );
}
